import type {Workflow} from '@api';
import type {WorkflowKey} from '../workflow';

export function formatWorkflowKey(workflow: Workflow): WorkflowKey {
    return workflow.toLocaleLowerCase().replace(/_/, '-') as WorkflowKey;
}
